
<template>
    <div>
        <breadcrumb
            :routerList="[{to:'/agent/weekMeetingTabs',title:'网络运营会列表'},{title:'查看网络运营会'}]"/>
        <div class="h-content">
            <div class="h-row h-mrt0">
                <div class="h-rowIn">
                    <div class="h-rowBox">
                        <div class="h-rowCon">
                            <div class="h-pieceIn2">
                                <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                    <h1>查看网络运营会</h1>
                                </div>
                                <div class="h-pieceCon2">
                                    <div class="h-formLine">
                                        <div class="margin-top el-descriptions">
                                            <div class="el-descriptions__body">
                                                <table
                                                    class="meeting-table el-descriptions__table is-bordered bordered-spacing"                                                    style="table-layout: fixed; width: 100%;">
                                                    <tr>
                                                        <th colspan="12"
                                                            class="my-label el-descriptions-item__cell el-descriptions-item__label ">
                                                            客户基本信息
                                                        </th>
                                                    </tr>
                                                    <tr>
                                                        <th colspan="1"
                                                            class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                            客户名称
                                                        </th>
                                                        <td colspan="3"
                                                            class="el-descriptions-item__cell el-descriptions-item__content">
                                                            {{ formValue.agentName }}
                                                        </td>
                                                        <th colspan="1"
                                                            class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                            签约渠道
                                                        </th>
                                                        <td colspan="4"
                                                            class="el-descriptions-item__cell el-descriptions-item__content">
                                                            {{ formValue.channelCode | dictname('sales_region') }}
                                                        </td>
                                                        <th colspan="1"
                                                            class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                            所在省区
                                                        </th>
                                                        <td colspan="2"
                                                            class="el-descriptions-item__cell el-descriptions-item__content">
                                                            {{ formValue.provinceCode | dictname('YlSalesArea_chanpin') }}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th colspan="1"
                                                            class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                            召开人
                                                        </th>
                                                        <td colspan="3"
                                                            class="el-descriptions-item__cell el-descriptions-item__content">
                                                            {{ formValue.conveneName }}
                                                        </td>
                                                        <th colspan="1"
                                                            class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                            参会人
                                                        </th>
                                                        <td colspan="4"
                                                            class="el-descriptions-item__cell el-descriptions-item__content">
                                                            {{ formValue.participants }}
                                                        </td>
                                                        <th colspan="1"
                                                            class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                            运营会时间
                                                        </th>
                                                        <td colspan="2"
                                                            class="el-descriptions-item__cell el-descriptions-item__content">
                                                            {{ formValue.weekTime }}
                                                        </td>
                                                    </tr>
                                                    <!-- 进销存现状 -->
                                                    <tr>
                                                        <th colspan="12"
                                                            class="my-label el-descriptions-item__cell el-descriptions-item__label">
                                                            进销存现状（销额.万元）
                                                        </th>
                                                    </tr>
                                                    <tr>
                                                        <th colspan="4"
                                                            class="my-labelhead el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                            进（进货：下单金额）
                                                        </th>
                                                        <th colspan="4"
                                                            class="my-labelhead el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                            销（销售：售后安装金额）
                                                        </th>
                                                        <th colspan="4"
                                                            class="my-labelhead el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                            存（库存：结余在库金额）
                                                        </th>
                                                    </tr>
                                                    <!--年度-->
                                                    <tr>
                                                        <th colspan="1" rowspan="3"
                                                            class="my-labelhead el-descriptions-item__cell el-descriptions-item__label">
                                                            年度
                                                        </th>
                                                        <th colspan="1"
                                                            class="my-labelhead el-descriptions-item__cell el-descriptions-item__label">
                                                            年度进货目标
                                                        </th>
                                                        <td colspan="2"
                                                            class="el-descriptions-item__cell el-descriptions-item__content">
                                                            {{ formValue.yearTargetAmount }}
                                                        </td>
                                                        <th colspan="1"
                                                            class="my-labelhead el-descriptions-item__cell el-descriptions-item__label">
                                                            年度出货目标
                                                        </th>
                                                        <td colspan="1"
                                                            class="el-descriptions-item__cell el-descriptions-item__content">
                                                            {{ formValue.yearTargetSaleAmount }}
                                                        </td>
                                                        <th colspan="1"
                                                            class="my-labelhead el-descriptions-item__cell el-descriptions-item__label">
                                                            直销
                                                        </th>
                                                        <th colspan="1"
                                                            class="my-labelhead el-descriptions-item__cell el-descriptions-item__label">
                                                            分销
                                                        </th>
                                                        <th colspan="2"
                                                            class="my-labelhead el-descriptions-item__cell el-descriptions-item__label">
                                                            年底期望库存金额
                                                        </th>
                                                        <td colspan="2"
                                                            class="el-descriptions-item__cell el-descriptions-item__content">
                                                            {{ formValue.endYearStockAmount }}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th colspan="1"
                                                            class="my-labelhead el-descriptions-item__cell el-descriptions-item__label">
                                                            年度进货实际
                                                        </th>
                                                        <td colspan="2"
                                                            class="el-descriptions-item__cell el-descriptions-item__content">
                                                            {{ formValue.yearActualAmount }}
                                                        </td>
                                                        <th colspan="1"
                                                            class="my-labelhead el-descriptions-item__cell el-descriptions-item__label">
                                                            年度出货实际
                                                        </th>
                                                        <td colspan="1"
                                                            class="el-descriptions-item__cell el-descriptions-item__content">
                                                            {{ formValue.yearActualSaleAmount }}
                                                        </td>
                                                        <td colspan="1"
                                                            class="el-descriptions-item__cell el-descriptions-item__content">
                                                            {{ formValue.directSaleAmount }}
                                                        </td>
                                                        <td colspan="1"
                                                            class="el-descriptions-item__cell el-descriptions-item__content">
                                                            {{ formValue.distributionSaleAmount }}
                                                        </td>
                                                        <th colspan="2"
                                                            class="my-labelhead el-descriptions-item__cell el-descriptions-item__label">
                                                            期初库存金额
                                                        </th>
                                                        <td colspan="2"
                                                            class="el-descriptions-item__cell el-descriptions-item__content">
                                                            {{ formValue.beginStockAmount }}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th colspan="1"
                                                            class="my-labelhead el-descriptions-item__cell el-descriptions-item__label">
                                                            完成率
                                                        </th>
                                                        <td colspan="2"
                                                            class="el-descriptions-item__cell el-descriptions-item__content">
                                                            {{ formValue.purchaseCompleteRate }}
                                                        </td>
                                                        <th colspan="1"
                                                            class="my-labelhead el-descriptions-item__cell el-descriptions-item__label">
                                                            完成率
                                                        </th>
                                                        <td colspan="3"
                                                            class="el-descriptions-item__cell el-descriptions-item__content">
                                                            {{ formValue.saleCompleteRate }}
                                                        </td>
                                                        <th colspan="2"
                                                            class="my-labelhead el-descriptions-item__cell el-descriptions-item__label">
                                                            库存消化目标
                                                        </th>
                                                        <td colspan="2"
                                                            class="el-descriptions-item__cell el-descriptions-item__content">
                                                            {{ formValue.stockDigestionTarget }}
                                                        </td>
                                                    </tr>
                                                    <!--月度-->
                                                    <tr>
                                                        <th colspan="1" rowspan="3"
                                                            class="my-labelhead el-descriptions-item__cell el-descriptions-item__label">
                                                            月度
                                                        </th>
                                                        <th colspan="1"
                                                            class="my-labelhead el-descriptions-item__cell el-descriptions-item__label">
                                                            月度进货目标
                                                        </th>
                                                        <td colspan="2"
                                                            class="el-descriptions-item__cell el-descriptions-item__content">
                                                            {{ formValue.monthTargetAmount }}
                                                        </td>
                                                        <th colspan="1" rowspan="2"
                                                            class="my-labelhead el-descriptions-item__cell el-descriptions-item__label">
                                                            月度出货预测
                                                        </th>
                                                        <th colspan="1"
                                                            class="my-labelhead el-descriptions-item__cell el-descriptions-item__label">
                                                            本月预测安装金额
                                                        </th>
                                                        <th colspan="1"
                                                            class="my-labelhead el-descriptions-item__cell el-descriptions-item__label">
                                                            直销
                                                        </th>
                                                        <th colspan="1"
                                                            class="my-labelhead el-descriptions-item__cell el-descriptions-item__label">
                                                            分销
                                                        </th>
                                                        <th colspan="2"
                                                            class="my-labelhead el-descriptions-item__cell el-descriptions-item__label">
                                                            期末库存金额
                                                        </th>
                                                        <td colspan="2"
                                                            class="el-descriptions-item__cell el-descriptions-item__content">
                                                            {{ formValue.endStockAmount }}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th colspan="1"
                                                            class="my-labelhead el-descriptions-item__cell el-descriptions-item__label">
                                                            月度进货预测
                                                        </th>
                                                        <td colspan="2"
                                                            class="el-descriptions-item__cell el-descriptions-item__content">
                                                            {{ formValue.monthTargetPurchaseAmount }}
                                                        </td>
                                                        <td colspan="1"
                                                            class="el-descriptions-item__cell el-descriptions-item__content">
                                                            {{ formValue.monthTargetInstallAmount }}
                                                        </td>
                                                        <td colspan="1"
                                                            class="el-descriptions-item__cell el-descriptions-item__content">
                                                            {{ formValue.monthDirectSaleAmount }}
                                                        </td>
                                                        <td colspan="1"
                                                            class="el-descriptions-item__cell el-descriptions-item__content">
                                                            {{ formValue.monthDistributionSaleAmount }}
                                                        </td>
                                                        <th colspan="2" rowspan="2"
                                                            class="my-labelhead el-descriptions-item__cell el-descriptions-item__label">
                                                            实际盘点金额(实际纠偏)
                                                        </th>
                                                        <td colspan="2" rowspan="2"
                                                            class="el-descriptions-item__cell el-descriptions-item__content">
                                                            {{ formValue.monthActualStockDigestionAmount }}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th colspan="1"
                                                            class="my-labelhead el-descriptions-item__cell el-descriptions-item__label">
                                                            完成率
                                                        </th>
                                                        <td colspan="2"
                                                            class="el-descriptions-item__cell el-descriptions-item__content">
                                                            {{ formValue.monthPurchaseCompleteRate }}
                                                        </td>
                                                        <th colspan="1"
                                                            class="my-labelhead el-descriptions-item__cell el-descriptions-item__label">
                                                            出货率
                                                        </th>
                                                        <td colspan="3"
                                                            class="el-descriptions-item__cell el-descriptions-item__content">
                                                            {{ formValue.monthSaleCompleteRate }}
                                                        </td>
                                                    </tr>

                                                    <!-- 库存消化关键任务落地进展 -->
                                                    <tr>
                                                        <th colspan="12"
                                                            class="my-label el-descriptions-item__cell el-descriptions-item__label">
                                                            库存消化关键任务落地进展
                                                        </th>
                                                    </tr>

                                                    <!-- 直销业务 -->
                                                    <tr>
                                                        <th colspan="1" :rowspan="3 + formValue.directSaleList.length"
                                                            class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                            直销业务
                                                        </th>
                                                        <th colspan="2"
                                                            class="my-labelhead el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                            用户名称
                                                        </th>
                                                        <th colspan="1"
                                                            class="my-labelhead el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                            用户分类
                                                        </th>
                                                        <th colspan="1"
                                                            class="my-labelhead el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                            金额
                                                        </th>
                                                        <th colspan="2"
                                                            class="my-labelhead el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                            项目名称
                                                        </th>
                                                        <th colspan="2"
                                                            class="my-labelhead el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                            进度与关键任务互认
                                                        </th>
                                                        <th colspan="1"
                                                            class="my-labelhead el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                            上次纪要闭环结果
                                                        </th>
                                                        <th colspan="2"
                                                            class="my-labelhead el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                            描述进展
                                                        </th>
                                                    </tr>
                                                    <tr v-for="(item, index) in formValue.directSaleList" :key="'direct_' + index">

                                                        <td colspan="2"
                                                            class="el-descriptions-item__cell el-descriptions-item__content">
                                                            {{ item.userName }}
                                                        </td>
                                                        <td colspan="1"
                                                            class="el-descriptions-item__cell el-descriptions-item__content">
                                                            {{ item.userType }}
                                                        </td>
                                                        <td colspan="1"
                                                            class="el-descriptions-item__cell el-descriptions-item__content">
                                                            {{ item.amount }}
                                                        </td>
                                                        <td colspan="2"
                                                            class="el-descriptions-item__cell el-descriptions-item__content">
                                                            {{ item.projectName }}
                                                        </td>
                                                        <td colspan="2"
                                                            class="el-descriptions-item__cell el-descriptions-item__content">
                                                            {{ item.progress }}
                                                        </td>
                                                        <td colspan="1"
                                                            class="el-descriptions-item__cell el-descriptions-item__content">
                                                            {{ item.lastResult }}
                                                        </td>
                                                        <td colspan="2"
                                                            class="el-descriptions-item__cell el-descriptions-item__content">
                                                            {{ item.updateDescription }}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th colspan="1"
                                                            class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                            签约目标用户数
                                                        </th>
                                                        <td colspan="1"
                                                            class="el-descriptions-item__cell el-descriptions-item__content">
                                                            <div style="text-align: right;">{{ formValue.targetUserNum }}</div>
                                                        </td>
                                                        <th colspan="1"
                                                            class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                            累计覆盖用户数
                                                        </th>
                                                        <td colspan="1"
                                                            class="el-descriptions-item__cell el-descriptions-item__content">
                                                            <div style="text-align: right;">{{ formValue.leijiUserNum }}</div>
                                                        </td>
                                                        <th colspan="2"
                                                            class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                            当年覆盖用户数
                                                        </th>
                                                        <td colspan="2"
                                                            class="el-descriptions-item__cell el-descriptions-item__content">
                                                            <div style="text-align: right;">{{ formValue.yearUserNum }}</div>
                                                        </td>
                                                        <th colspan="1"
                                                            class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                            当年覆盖率
                                                        </th>
                                                        <td colspan="2"
                                                            class="el-descriptions-item__cell el-descriptions-item__content">
                                                            <div style="text-align: right;">{{ formValue.yearCoverage }}</div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th colspan="1"
                                                            class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                            未覆盖用户数
                                                        </th>
                                                        <td colspan="1"
                                                            class="el-descriptions-item__cell el-descriptions-item__content">
                                                            {{ formValue.noCoveredNoloudUserNum }}
                                                        </td>
                                                        <th colspan="1"
                                                            class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                            行动计划
                                                        </th>
                                                        <td v-if="formValue.noCoveredNoloudUserNum==0" colspan="8"
                                                            class="el-descriptions-item__cell el-descriptions-item__content"                                                            style="white-space: pre-line;text-align: left!important;">
                                                            {{ formValue.handInput }}
                                                        </td>
                                                        <td v-if="formValue.noCoveredNoloudUserNum>0" colspan="4"
                                                            class="el-descriptions-item__cell el-descriptions-item__content"                                                            style="white-space: pre-line;text-align: left!important;">
                                                            {{ formValue.weekPlan }}
                                                        </td>
                                                        <td v-if="formValue.noCoveredNoloudUserNum>0" colspan="4"
                                                            class="el-descriptions-item__cell el-descriptions-item__content"                                                            style="white-space: pre-line;text-align: left!important;">
                                                            {{ formValue.handInput }}
                                                        </td>
                                                    </tr>

                                                    <!-- 分销业务 -->
                                                    <tr>
                                                        <th colspan="1" :rowspan="formValue.distributionPlanList.length + 1"
                                                            class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                            分销业务
                                                        </th>
                                                        <th colspan="1"
                                                            class="my-labelhead el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                            分类
                                                        </th>
                                                        <th colspan="1"
                                                            class="my-labelhead el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                            行动方向
                                                        </th>
                                                        <th colspan="2"
                                                            class="my-labelhead el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                            本月计划
                                                        </th>
                                                        <th colspan="2"
                                                            class="my-labelhead el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                            预计完成时间
                                                        </th>
                                                        <th colspan="2"
                                                            class="my-labelhead el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                            本周进度
                                                        </th>
                                                        <th colspan="1"
                                                            class="my-labelhead el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                            上次纪要闭环结果
                                                        </th>
                                                        <th colspan="2"
                                                            class="my-labelhead el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                            描述进展
                                                        </th>
                                                    </tr>
                                                    <tr v-for="(item, index) in formValue.distributionPlanList"  :key="'dist_plan_' + index">

                                                        <td colspan="1"
                                                            class="el-descriptions-item__cell el-descriptions-item__content">
                                                            {{ item.category }}
                                                        </td>
                                                        <td colspan="1"
                                                            class="el-descriptions-item__cell el-descriptions-item__content">
                                                            {{ item.actionDirection }}
                                                        </td>
                                                        <td colspan="2"
                                                            class="el-descriptions-item__cell el-descriptions-item__content">
                                                            {{ item.monthPlan }}
                                                        </td>
                                                        <td colspan="2"
                                                            class="el-descriptions-item__cell el-descriptions-item__content">
                                                            {{ item.expectedTime }}
                                                        </td>
                                                        <td colspan="2"
                                                            class="el-descriptions-item__cell el-descriptions-item__content">
                                                            {{ item.weekProgress }}
                                                        </td>
                                                        <td colspan="1"
                                                            class="el-descriptions-item__cell el-descriptions-item__content">
                                                            {{ item.lastResult }}
                                                        </td>
                                                        <td colspan="2"
                                                            class="el-descriptions-item__cell el-descriptions-item__content">
                                                            {{ item.updateDescription }}
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <th colspan="1"
                                                            class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                            会议相关照片
                                                        </th>

                                                        <td colspan="11" class="el-descriptions-item__cell el-descriptions-item__content">
                                                            <div v-for="(img, idx) in srcList" :key="idx" style="float: left;width:200px;margin-right: 10px;">
                                                                <el-image  style="width: 200px; height: 100px"
                                                                    :src="img"
                                                                     :preview-src-list="srcList">
                                                                </el-image>
                                                            </div>
                                                        </td>
                                                    </tr>

                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="h-txtCenter" style="margin: 0.3rem 0;">
                <el-button class="h-btn h-bBtn h-bgwhite" @click="backS">返回</el-button>
            </div>
        </div>
    </div>
</template>
<script>import weeklyMeetingApi from "@/api/loud/weeklyMeeting/weeklyMeetingApi";

export default {
    data() {
        return {
            formValue: {
                agentName: '',
                agentCode: '',
                channelName: '',
                channelCode: '',
                provinceName: '',
                provinceCode: '',
                conveneCode: '',
                conveneName: '',
                participants: '',
                weekTime: '',

                yearTargetAmount: '',
                yearTargetSaleAmount: '',
                endYearStockAmount: '',
                yearActualAmount: '',
                yearActualSaleAmount: '',
                directSaleAmount: '',
                distributionSaleAmount: '',
                beginStockAmount: '',
                endStockAmount: '',
                purchaseCompleteRate: '',
                saleCompleteRate: '',
                stockDigestionTarget: '',

                monthTargetAmount: '',
                monthTargetInstallAmount: '',
                monthDirectSaleAmount: '',
                monthDistributionSaleAmount: '',
                monthTargetPurchaseAmount: '',
                monthActualStockDigestionAmount: '',
                monthPurchaseCompleteRate: '',
                monthSaleCompleteRate: '',

                targetUserNum: '',
                leijiUserNum: '',
                yearUserNum: '',
                leijiCoverage: '',
                yearCoverage: '',
                noCoveredNoloudUserNum: '',
                weekPlan: '',
                handInput: '',

                directSaleList: [],
                distributionPlanList: [],
            },
            url: '',
            srcList: []
        }
    },
    created() {
        const id = this.$route.query.id;
        if (id) {
            this.query(id);
        }
    },
    methods: {
        query(id) {
            weeklyMeetingApi.selectById2026(id).then(res => {
                if (res.f) {
                    this.formValue = {
                        ...this.formValue,
                        ...res.obj,
                        directSaleList: res.obj.directSaleList || [],
                        distributionPlanList: res.obj.distributionPlanList || [],
                    };

                    //查询文件
                    weeklyMeetingApi.selectMeetingReportFile({fileId:this.formValue.id}).then(rd => {
                        rd.msg.forEach(obj => {
                            this.srcList.push('https://'+process.env.VUE_APP_AJAXURL+'/'+obj.saveurl);
                        })
                        this.url = 'https://'+process.env.VUE_APP_AJAXURL+'/'+rd.msg[0].saveurl;
                    })
                }
            })
        },
        backS() {
            this.$router.go(-1);
        },
    }
}
</script>
<style scoped lang="scss">.h-rowCon {
    font-size: 14px !important;
    font-weight: 400 !important;
}

::v-deep .el-form-item__content {
    line-height: 30px;
}

::v-deep .meeting-table th, td {
    text-align: center !important;
    border: 1px solid #303133 !important;
    border-right: none !important;
    border-bottom: none !important;
    vertical-align: middle;
    font-weight: normal !important;
}

.bordered-spacing {
    border-spacing: 0 !important;
    border-right: 1px solid #303133 !important;
    border-bottom: 1px solid #303133 !important;
}

::v-deep .my-label {
    background: #ffebe5 !important;
}

::v-deep .my-labelhead {
    background: #f5f7fa !important;
}

::v-deep .el-form-item {
    margin-bottom: 0 !important;
}

::v-deep .el-descriptions :not(.is-bordered) .el-descriptions-item__cell {
    padding-bottom: 0;
}

::v-deep .el-descriptions .is-bordered .el-descriptions-item__cell {
    padding: 6px;
}
</style>
